<template lang="pug">
q-breadcrumbs.text-grey(
    active-color="grey"
    separator-color="grey")
    q-breadcrumbs-el(label="Главная" to="/" title="Главная")
    q-breadcrumbs-el(
        v-if="!catalog"
        v-for="crumb in routeObj"
        :label="crumb.title"
        :to="crumb.link || null"
        :title="crumb.title")
    q-breadcrumbs-el(
        v-else
        v-for="crumb in routeObj"
        :label="crumb.name"
        :to="crumb.slug_name || null"
        :title="crumb.name")
</template>

<script>
export default {
    name: 'Breadcrumbs',
    props: {
        routeObj: {
            type: Array,
            required: true,
        },
        catalog: {
            type: Boolean,
            default: () => false,
        },
    },
};
</script>
